import useFetch from "../../hooks/useFetch";
import { useStoreState } from "../store/useStore";

const useAction = (base?: string) => {
  const { baseUrl } = useStoreState();

  const { get } = useFetch(base ? base : baseUrl);

  const getNotification = async <T>() => {
    return get<T>(`uapi/v1/notification/unread/count?use_new=true`);
  };

  return {
    getNotification
  };
};

export default useAction;
